import React from 'react';
import Stack from 'atoms/Layout/Stack/Stack';
import Button, { ButtonProps } from 'atoms/Button/Button';
import HeadingAndSupportingText from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import { TypographyProps } from 'atoms/Typography/Typography';
import { cssVar } from 'src/app/styles/helper';

export interface SmallAccentLineMetricItemProps {
  metricNumber: string;
  metricDescription: string;
  buttonProps?: ButtonProps;
  metricNumberProps?: Omit<TypographyProps, 'children' | 'text'>;
  metricDescriptionProps?: Omit<TypographyProps, 'children' | 'text'>;
}

const SmallAccentLineMetricItem = ({
  metricNumber,
  metricDescription,
  buttonProps,
  metricNumberProps = {},
  metricDescriptionProps = {},
}: SmallAccentLineMetricItemProps): JSX.Element => {
  const renderContent = (): JSX.Element => (
    <>
      <HeadingAndSupportingText
        heading={{
          type: 'heading',
          size: 'lg',
          as: 'p',
          fontWeight: 'font-weight-semibold',
          letterSpacing: -1,
          color: 'text-brand-tertiary-alt',
          ...metricNumberProps,
          text: metricNumber,
        }}
        supportingText={{
          type: 'paragraph',
          size: 'lg',
          fontWeight: 'font-weight-semibold',
          color: 'text-primary',
          ...metricDescriptionProps,
          text: metricDescription,
        }}
        gap='spacing-none'
      />
      {buttonProps && (
        <Stack maxWidth='width-fit-content'>
          <Button {...buttonProps} />
        </Stack>
      )}
    </>
  );

  return (
    <Stack
      direction='column'
      gap='spacing-xl'
      paddingLeft='spacing-3xl'
      marginBottom='spacing-auto'
      border={`2px solid ${cssVar('fg-brand-primary-alt')}`}
      borderTop='none'
      borderRight='none'
      borderBottom='none'
    >
      {renderContent()}
    </Stack>
  );
};

export default SmallAccentLineMetricItem;
